import { useRef, useEffect, useState } from "react";
import Footer from "../Footer";
import Header from "../Header";
import Img1 from "../assets/img/Blogs/SalesAnalytics/1.png";
import Img2 from "../assets/img/Blogs/SalesAnalytics/2.png";
import Img3 from "../assets/img/Blogs/SalesAnalytics/3.png";
import Img4 from "../assets/img/Blogs/SalesAnalytics/4.png";

const TransformSalesDataIntoRevenue = () => {
  return (
    <>
      <Header></Header>
      <div className="mainContent blogDtlWrap">
        <div className="topPageBanner">
          <div className="container">
            <div className="row justify-content-center">
              <div className="col-md-10">
                <div className="titleWrap">
                  <h2>
                    Transform Your Sales Data Into Revenue-Driving Insights
                  </h2>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="staffAugBenefitsWrap aiPBenefitsWrap">
          <div className="container">
            <div className="row">
              <div className="col-md-12">
                <div className="ttlWrap">
                  <h2>
                    Unlock the power of your sales data with advanced analytics
                    and business intelligence solutions that deliver measurable
                    results.
                  </h2>
                  <p>Key Stats Our Clients Achieve:</p>
                </div>
              </div>
            </div>
            <div className="row justify-content-center">
              <div className="col-md-12">
                <ul>
                  <li>
                    <div className="itemWrap">
                      <div className="imgWrap">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          version="1.1"
                          width="62"
                          height="62"
                          x="0"
                          y="0"
                          viewBox="0 0 682.667 682.667"
                        >
                          <g>
                            <defs>
                              <clipPath id="a" clipPathUnits="userSpaceOnUse">
                                <path
                                  d="M0 512h512V0H0Z"
                                  fill="#6cdc99"
                                  opacity="1"
                                  data-original="#6cdc99"
                                ></path>
                              </clipPath>
                            </defs>
                            <path
                              d="M0 0h120.091"
                              transform="matrix(1.33333 0 0 -1.33333 139.67 100.223)"
                              fill="none"
                              stroke="#6cdc99"
                              stroke-width="15"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                              stroke-miterlimit="10"
                              stroke-dasharray="none"
                              data-original="#6cdc99"
                              opacity="0.45"
                            ></path>
                            <path
                              d="M0 0h120.091"
                              transform="matrix(1.33333 0 0 -1.33333 139.67 152.538)"
                              fill="none"
                              stroke="#6cdc99"
                              stroke-width="15"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                              stroke-miterlimit="10"
                              stroke-dasharray="none"
                              data-original="#6cdc99"
                              opacity="0.45"
                            ></path>
                            <path
                              d="M0 0h245.881"
                              transform="matrix(1.33333 0 0 -1.33333 139.67 260.111)"
                              fill="none"
                              stroke="#6cdc99"
                              stroke-width="15"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                              stroke-miterlimit="10"
                              stroke-dasharray="none"
                              data-original="#6cdc99"
                              opacity="0.45"
                            ></path>
                            <path
                              d="M0 0h245.881"
                              transform="matrix(1.33333 0 0 -1.33333 139.67 335.247)"
                              fill="none"
                              stroke="#6cdc99"
                              stroke-width="15"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                              stroke-miterlimit="10"
                              stroke-dasharray="none"
                              data-original="#6cdc99"
                              opacity="0.45"
                            ></path>
                            <path
                              d="M0 0h216.095"
                              transform="matrix(1.33333 0 0 -1.33333 139.67 410.383)"
                              fill="none"
                              stroke="#6cdc99"
                              stroke-width="15"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                              stroke-miterlimit="10"
                              stroke-dasharray="none"
                              data-original="#6cdc99"
                              opacity="0.45"
                            ></path>
                            <path
                              d="M0 0h135.844"
                              transform="matrix(1.33333 0 0 -1.33333 139.67 485.52)"
                              fill="none"
                              stroke="#6cdc99"
                              stroke-width="15"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                              stroke-miterlimit="10"
                              stroke-dasharray="none"
                              data-original="#6cdc99"
                              opacity="0.45"
                            ></path>
                            <g
                              clip-path="url(#a)"
                              transform="matrix(1.33333 0 0 -1.33333 0 682.667)"
                            >
                              <path
                                d="M0 0h-88.588c-10.115 0-18.315 8.2-18.315 18.315v88.588"
                                transform="translate(409.566 397.597)"
                                fill="none"
                                stroke="#6cdc99"
                                stroke-width="15"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                                stroke-miterlimit="10"
                                stroke-dasharray="none"
                                data-original="#6cdc99"
                                opacity="0.45"
                              ></path>
                              <path
                                d="M0 0c-24.472 0-44.31 19.838-44.31 44.309 0 24.472 19.838 44.31 44.31 44.31s44.31-19.838 44.31-44.31C44.31 19.838 24.472 0 0 0Zm83.574 61.145v0a11.71 11.71 0 0 0-11.077 7.941 75.987 75.987 0 0 1-3.703 8.936c-2.214 4.511-1.349 9.924 2.204 13.477L71 91.5c4.569 4.57 4.569 11.978 0 16.547l-7.262 7.262c-4.569 4.569-11.977 4.569-16.547 0l-.002-.002c-3.552-3.553-8.966-4.417-13.476-2.203a76.172 76.172 0 0 1-8.937 3.703 11.71 11.71 0 0 0-7.941 11.076c0 6.462-5.238 11.7-11.7 11.7h-10.27c-6.462 0-11.7-5.238-11.7-11.7a11.71 11.71 0 0 0-7.941-11.076 76.172 76.172 0 0 1-8.937-3.703c-4.511-2.214-9.924-1.35-13.476 2.203l-.002.002c-4.57 4.569-11.978 4.569-16.547 0L-71 108.047c-4.569-4.569-4.569-11.977 0-16.547l.002-.001c3.553-3.553 4.418-8.966 2.203-13.477a76.152 76.152 0 0 1-3.702-8.936 11.712 11.712 0 0 0-11.077-7.941c-6.462 0-11.7-5.239-11.7-11.701v-10.27c0-6.462 5.238-11.7 11.7-11.7 5.012 0 9.456-3.198 11.077-7.941a76.081 76.081 0 0 1 3.702-8.936c2.215-4.511 1.35-9.924-2.203-13.477L-71-2.882c-4.569-4.569-4.569-11.977 0-16.547l7.262-7.261c4.569-4.57 11.977-4.57 16.547 0l.002.002c3.552 3.552 8.965 4.417 13.476 2.203a76.001 76.001 0 0 1 8.937-3.703c4.743-1.621 7.941-6.064 7.941-11.077 0-6.462 5.238-11.7 11.7-11.7h10.27c6.462 0 11.7 5.238 11.7 11.7 0 5.013 3.198 9.456 7.941 11.077a76.001 76.001 0 0 1 8.937 3.703c4.51 2.214 9.924 1.349 13.476-2.203l.002-.002c4.57-4.57 11.978-4.57 16.547 0L71-19.429c4.569 4.57 4.569 11.978 0 16.547l-.002.002C67.445.673 66.58 6.086 68.794 10.597a75.916 75.916 0 0 1 3.703 8.936c1.621 4.743 6.064 7.941 11.077 7.941 6.462 0 11.7 5.238 11.7 11.7v10.27c0 6.462-5.238 11.701-11.7 11.701z"
                                transform="translate(365.157 58.465)"
                                fill="none"
                                stroke="#6cdc99"
                                stroke-width="15"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                                stroke-miterlimit="10"
                                stroke-dasharray="none"
                                data-original="#6cdc99"
                                opacity="0.45"
                              ></path>
                              <path
                                d="M0 0v190.347L-106.903 297.25h-226.854c-13.388 0-24.241-10.853-24.241-24.24v-406.602c0-13.387 10.853-24.24 24.241-24.24H-157.9"
                                transform="translate(409.566 207.25)"
                                fill="none"
                                stroke="#6cdc99"
                                stroke-width="15"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                                stroke-miterlimit="10"
                                stroke-dasharray="none"
                                data-original="#6cdc99"
                              ></path>
                            </g>
                          </g>
                        </svg>
                      </div>
                      <div className="dataWrap">
                        <h2>25% Performance Improvement</h2>
                        <p>Average increase in sales team efficiency</p>
                      </div>
                    </div>
                  </li>
                  <li>
                    <div className="itemWrap">
                      <div className="imgWrap">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          version="1.1"
                          width="62"
                          height="62"
                          x="0"
                          y="0"
                          viewBox="0 0 682.667 682.667"
                        >
                          <g>
                            <defs>
                              <clipPath id="a" clipPathUnits="userSpaceOnUse">
                                <path
                                  d="M0 512h512V0H0Z"
                                  fill="#67a9d5"
                                  opacity="0.35"
                                  data-original="#67a9d5"
                                ></path>
                              </clipPath>
                            </defs>
                            <path
                              d="M0 0h141.485l27.006 90.369H-12.757"
                              transform="matrix(1.33333 0 0 -1.33333 257.672 383.628)"
                              fill="none"
                              stroke="#67a9d5"
                              stroke-width="20"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                              stroke-miterlimit="10"
                              stroke-dasharray="none"
                              data-original="#67a9d5"
                              opacity="0.35"
                            ></path>
                            <path
                              d="M0 0h-131.957l-20.668 160.11h-37.587"
                              transform="matrix(1.33333 0 0 -1.33333 437.86 435.441)"
                              fill="none"
                              stroke="#67a9d5"
                              stroke-width="20"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                              stroke-miterlimit="10"
                              stroke-dasharray="none"
                              data-original="#67a9d5"
                              opacity="0.35"
                            ></path>
                            <g
                              clip-path="url(#a)"
                              transform="matrix(1.33333 0 0 -1.33333 0 682.667)"
                            >
                              <path
                                d="M0 0c0-12.442-10.071-22.529-22.495-22.529C-34.919-22.529-44.99-12.442-44.99 0c0 12.443 10.071 22.53 22.495 22.53C-10.071 22.53 0 12.443 0 0Z"
                                transform="translate(242.644 162.873)"
                                fill="none"
                                stroke="#67a9d5"
                                stroke-width="20"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                                stroke-miterlimit="10"
                                stroke-dasharray="none"
                                data-original="#67a9d5"
                                opacity="0.35"
                              ></path>
                              <path
                                d="M0 0c0-12.442-10.071-22.529-22.495-22.529C-34.919-22.529-44.99-12.442-44.99 0c0 12.443 10.071 22.53 22.495 22.53C-10.071 22.53 0 12.443 0 0Z"
                                transform="translate(332.929 162.889)"
                                fill="none"
                                stroke="#67a9d5"
                                stroke-width="20"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                                stroke-miterlimit="10"
                                stroke-dasharray="none"
                                data-original="#67a9d5"
                                opacity="0.35"
                              ></path>
                              <path
                                d="M0 0h-240.825c-21.093 0-38.193 17.1-38.193 38.193v41.639H38.193V38.193C38.193 17.1 21.093 0 0 0Z"
                                transform="translate(376.413 10)"
                                fill="none"
                                stroke="#67a9d5"
                                stroke-width="20"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                                stroke-miterlimit="10"
                                stroke-dasharray="none"
                                data-original="#67a9d5"
                              ></path>
                              <path
                                d="M0 0h-317.211v374.065c0 21.044 17.14 38.103 38.284 38.103h240.643C-17.141 412.168 0 395.109 0 374.065Z"
                                transform="translate(414.606 89.832)"
                                fill="none"
                                stroke="#67a9d5"
                                stroke-width="20"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                                stroke-miterlimit="10"
                                stroke-dasharray="none"
                                data-original="#67a9d5"
                              ></path>
                              <path
                                d="M0 0h13.333"
                                transform="translate(249.333 49.916)"
                                fill="none"
                                stroke="#67a9d5"
                                stroke-width="20"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                                stroke-miterlimit="10"
                                stroke-dasharray="none"
                                data-original="#67a9d5"
                                opacity="0.45"
                              ></path>
                              <path
                                d="M0 0h94.979"
                                transform="translate(208.51 462.447)"
                                fill="none"
                                stroke="#67a9d5"
                                stroke-width="20"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                                stroke-miterlimit="10"
                                stroke-dasharray="none"
                                data-original="#67a9d5"
                              ></path>
                            </g>
                          </g>
                        </svg>
                      </div>
                      <div className="dataWrap">
                        <h2>30% Higher Sales Growth</h2>
                        <p>Boost in revenue generation within just 90 days</p>
                      </div>
                    </div>
                  </li>
                  <li>
                    <div className="itemWrap">
                      <div className="imgWrap">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          version="1.1"
                          width="62"
                          height="62"
                          x="0"
                          y="0"
                          viewBox="0 0 512 512"
                        >
                          <g>
                            <path
                              d="M192 464h-64a8 8 0 0 0 0 16h64a8 8 0 0 0 0-16z"
                              fill="#cb9cee"
                              opacity="1"
                              data-original="#cb9cee"
                            ></path>
                            <path
                              d="M468 160H304V36a28.031 28.031 0 0 0-28-28H44a28.031 28.031 0 0 0-28 28v440a28.031 28.031 0 0 0 28 28h232a28.031 28.031 0 0 0 28-28V360h164a28.031 28.031 0 0 0 28-28V188a28.031 28.031 0 0 0-28-28zM197.75 24l-4 16h-67.5l-4-16zM288 476a12.01 12.01 0 0 1-12 12H44a12.01 12.01 0 0 1-12-12V36a12.01 12.01 0 0 1 12-12h61.75l6.49 25.94A8 8 0 0 0 120 56h80a8 8 0 0 0 7.76-6.06L214.25 24H276a12.01 12.01 0 0 1 12 12zm16-196h24v32h-24zm176 52a12.01 12.01 0 0 1-12 12H304v-16h32a8 8 0 0 0 8-8v-48a8 8 0 0 0-8-8h-32v-24h176zm0-108H304v-16h176zm0-32H304v-16h164a12.01 12.01 0 0 1 12 12z"
                              fill="#cb9cee"
                              opacity="1"
                              data-original="#cb9cee"
                            ></path>
                            <path
                              d="M456 264h-72a8 8 0 0 0 0 16h72a8 8 0 0 0 0-16zM456 288h-72a8 8 0 0 0 0 16h72a8 8 0 0 0 0-16zM456 312h-32a8 8 0 0 0 0 16h32a8 8 0 0 0 0-16zM160 160a96 96 0 1 0 96 96 96.108 96.108 0 0 0-96-96zm0 176a80 80 0 1 1 80-80 80.091 80.091 0 0 1-80 80z"
                              fill="#cf8fff"
                              opacity="0.15"
                              data-original="#cf8fff"
                            ></path>
                            <path
                              d="m202.343 226.343-51.094 51.094L124.8 257.6a8 8 0 1 0-9.6 12.8l32 24a8 8 0 0 0 10.457-.743l56-56a8 8 0 0 0-11.314-11.314z"
                              fill="#cf8fff"
                              opacity="0.15"
                              data-original="#cf8fff"
                            ></path>
                          </g>
                        </svg>
                      </div>
                      <div className="dataWrap">
                        <h2>Real-Time Analytics</h2>
                        <p>Make smarter, data-driven decisions instantly</p>
                      </div>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
        <div className="staffAugItroWrap staffAugValueWrap flexRevMob">
          <div className="container">
            <div className="row">
              <div className="col-md-6">
                <div className="dataWrap dataWrapPadLt">
                  <h2>Stop Guessing. Start Growing.</h2>
                  <p>
                    Most sales teams don’t fail because of a lack of effort—they
                    fail because of a lack of clarity.
                  </p>
                  <ul>
                    <li>
                      <strong>1.</strong> Teams drown in endless spreadsheets
                      but starve for real insights.
                    </li>
                    <li>
                      <strong>2.</strong> Revenue opportunities remain hidden in
                      scattered data.
                    </li>
                    <li>
                      <strong>3.</strong> Forecasts miss the mark, and reporting
                      consumes 40+ hours each week.
                    </li>
                  </ul>
                  <p>
                    At Hummingtec, we turn your sales chaos into clarity. Our
                    advanced analytics platform reveals the insights
                    top-performing companies rely on to consistently outpace
                    their competition.
                  </p>
                </div>
              </div>
              <div className="col-md-6">
                <div className="imgWrap">
                  <img src={Img1} className="img-fluid" alt="" />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="staffAugItroWrap staffAugValueWrap">
          <div className="container">
            <div className="row">
              <div className="col-md-6">
                <div className="imgWrap">
                  <img src={Img2} className="img-fluid" alt="" />
                </div>
              </div>
              <div className="col-md-6">
                <div className="dataWrap dataWrapPadLt">
                  <span>Our Core Services</span>
                  <h2>1. Sales Operations Analytics</h2>
                  <p>See Every Deal, Predict Every Outcome</p>
                  <p>
                    Stop managing in the dark—empower your team with real-time
                    intelligence.
                  </p>
                  <ul>
                    <li>
                      <strong>1. Performance Trends :</strong> Monitor team and
                      individual metrics instantly
                    </li>
                    <li>
                      <strong>2. Revenue Forecasting :</strong> Predict
                      quarterly outcomes with up to 95% accuracy
                    </li>
                    <li>
                      <strong>3. Bottleneck Identification :</strong> Spot
                      pipeline issues before they cost you deals
                    </li>
                    <li>
                      <strong>4. Activity Analysis :</strong> Double down on
                      actions that drive conversions
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="staffAugItroWrap staffAugValueWrap flexRevMob">
          <div className="container">
            <div className="row">
              <div className="col-md-6">
                <div className="dataWrap dataWrapPadLt">
                  <span>Our Core Services</span>
                  <h2>2. Pipeline Optimization</h2>
                  <p>Turn More Prospects Into Profit</p>
                  <p>
                    Your sales funnel is only as strong as your weakest stage.
                    Our AI-powered insights help you maximize every lead.
                  </p>
                  <ul>
                    <li>
                      <strong>1. Conversion Rate Analysis : </strong> Detect
                      high drop-off points and fix them
                    </li>
                    <li>
                      <strong>2. Deal Velocity Tracking : </strong> Shorten
                      cycles by 40% with faster closures
                    </li>
                    <li>
                      <strong>3. Lead Scoring Intelligence : </strong> Focus
                      only on buyers most likely to convert
                    </li>
                    <li>
                      <strong>4. Territory Performance : </strong> See which
                      regions or verticals bring the best ROI
                    </li>
                  </ul>
                </div>
              </div>
              <div className="col-md-6">
                <div className="imgWrap">
                  <img src={Img3} className="img-fluid" alt="" />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="staffAugItroWrap staffAugValueWrap">
          <div className="container">
            <div className="row">
              <div className="col-md-6">
                <div className="imgWrap">
                  <img src={Img4} className="img-fluid" alt="" />
                </div>
              </div>
              <div className="col-md-6">
                <div className="dataWrap dataWrapPadLt">
                  <span>Our Core Services</span>
                  <h2>3. Advanced Data Mining</h2>
                  <p>Discover Hidden Revenue Opportunities</p>
                  <p>
                    Go beyond surface-level metrics and uncover valuable growth
                    patterns.
                  </p>
                  <ul>
                    <li>
                      <strong>1. Customer Behavior Analysis :</strong> Reveal
                      buying patterns and triggers
                    </li>
                    <li>
                      <strong>2. Market Trend Detection :</strong> Anticipate
                      shifts with predictive analytics
                    </li>
                    <li>
                      <strong>3. Cross-sell/Upsell Intelligence :</strong>{" "}
                      Unlock expansion opportunities with existing customers
                    </li>
                    <li>
                      <strong>4. Competitive Analysis :</strong> Track rivals
                      and capture more market share
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="whyHumingtecSec">
          <div className="container">
            <div className="row">
              <div className="col-md-12">
                <div className="titleWrap">
                  <h2>Why Choose Hummingtec?</h2>
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-md-12">
                <div className="dataWrap">
                  <p>
                    Because growth doesn’t happen by accident. It happens when
                    data becomes a competitive advantage.
                  </p>
                  <p>
                    Our mission is simple: helping businesses transform raw
                    sales data into actionable strategies that accelerate growth
                    and maximize profit.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer></Footer>
    </>
  );
};
export default TransformSalesDataIntoRevenue;
